import api from '../api/contactForm'
import { fetchSection } from './api'

export const actionTypes = {
	SEND_INFO: 'contact/SEND_INFO',
	RESET_FORM: 'contact/RESET_FORM',
	RECEIVE_CONFIRMATION: 'contact/RECEIVE_CONFIRMATION',
	ERROR: 'contact/ERROR'
}

export const getContactInfo = (value, info) => {
	return (dispatch, getStore) => {
		dispatch(saveFormInfo(value, info))
    dispatch(fetchSection('contactForm'))
  }
}

export const sendContactForm = (params) => {
	return (dispatch) => {
    api.sendContactForm(params)
      .then((data) => {
        dispatch(receiveConfirmation(data))
      })
      .catch((err) => {
        console.error('Error: ', err)
        dispatch(error(err.join('\n')))
      })
  }
}

function saveFormInfo(data, info) {
  return {
    type: actionTypes.SEND_INFO,
    data, info
  }
}

function receiveConfirmation(data) {
  return {
    type: actionTypes.RECEIVE_CONFIRMATION
  }
}

export const resetForm = () => {
	return {
		type: actionTypes.RESET_FORM
	}
}

function error(APIdataerr) {
  return {
    type: actionTypes.ERROR,
    error: APIdataerr
  }
}



// WEBPACK FOOTER //
// ./src/actions/contactForm.js